import React, { Component } from 'react'
import { Formik, Form } from 'formik'
import Yup from './../../../../../helpers/custom-yup'
import styled from 'styled-components'
import { PasswordInput } from '../../../../../components/form-components/inputs.component'

import PropTypes from 'prop-types'

const schema = Yup.object().shape({
	password: Yup.string().password(),
	passwordConfirmation: Yup.string().equalToRequired(
		Yup.ref('password'),
		'As senhas digitadas não conferem'
	),
})

const StyledForm = styled.div`
	padding-bottom: 25px;
	width: 300px;
	@media (max-width: 600px) {
		width: 100%;
	}
`

const StyledInputContainer = styled.div`
	margin-top: 4.5rem;
`

export default class PasswordForm extends Component {
	constructor(props) {
		super(props)
		this.passwordRef = React.createRef()
		this.passwordConfirmationRef = React.createRef()
	}

	submit() {
		this.refs.form.submitForm()
	}

	render() {
		const { onSubmit } = this.props
		return (
			<Formik
				initialValues={{
					password: '',
					passwordConfirmation: '',
				}}
				onSubmit={onSubmit}
				validationSchema={schema}
				ref={'form'}
				render={(props) => (
					<Form noValidate>
						<StyledForm>
							<p className="static-information">
								A sua senha deve ter no mínimo 12 caracteres e conter
								pelo menos uma letra maiúscula, uma letra minúscula, 1
								número e 1 caractere especial
							</p>
							<br />
							<br />
							<PasswordInput
								elementRef={this.passwordRef}
								id="password"
								label="Senha"
								maxLength={256}
								{...props}
							/>
							<StyledInputContainer>
								<PasswordInput
									elementRef={this.passwordConfirmationRef}
									id="passwordConfirmation"
									label="Redigite a senha"
									maxLength={256}
									{...props}
								/>
							</StyledInputContainer>
						</StyledForm>
					</Form>
				)}
			/>
		)
	}
}

PasswordForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func,
}
